import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Shield, Smartphone } from "lucide-react";

interface MethodSelectorProps {
  value: 'totp' | 'sms';
  onChange: (method: 'totp' | 'sms') => void;
  disabled?: boolean;
}

export const MethodSelector = ({ value, onChange, disabled }: MethodSelectorProps) => {
  return (
    <div className="space-y-4">
      <Label className="text-base font-semibold">Choose your verification method</Label>
      
      <RadioGroup
        value={value}
        onValueChange={(val) => onChange(val as 'totp' | 'sms')}
        disabled={disabled}
        className="space-y-3"
      >
        <div 
          className="flex items-start space-x-3 rounded-lg border border-border p-4 cursor-pointer hover:bg-accent/50 transition-colors"
          onClick={() => !disabled && onChange('totp')}
          role="button"
          aria-pressed={value === 'totp'}
        >
          <RadioGroupItem value="totp" id="method-totp" className="mt-1" />
          <div className="flex-1 space-y-1">
            <Label
              htmlFor="method-totp"
              className="flex items-center gap-2 font-medium cursor-pointer"
            >
              <Shield className="h-4 w-4 text-godyspo-gold" />
              Authenticator App (TOTP)
            </Label>
            <p className="text-sm text-muted-foreground">
              More secure. Works offline. Use apps like Google Authenticator or Authy.
            </p>
          </div>
        </div>

        <div 
          className="flex items-start space-x-3 rounded-lg border border-border p-4 cursor-pointer hover:bg-accent/50 transition-colors"
          onClick={() => !disabled && onChange('sms')}
          role="button"
          aria-pressed={value === 'sms'}
        >
          <RadioGroupItem value="sms" id="method-sms" className="mt-1" />
          <div className="flex-1 space-y-1">
            <Label
              htmlFor="method-sms"
              className="flex items-center gap-2 font-medium cursor-pointer"
            >
              <Smartphone className="h-4 w-4 text-godyspo-gold" />
              SMS Text Message
            </Label>
            <p className="text-sm text-muted-foreground">
              Convenient. Receive codes via text. Requires phone signal.
            </p>
          </div>
        </div>
      </RadioGroup>
    </div>
  );
};
